// import {chartMonthly} from "./chartMonthly.js";
// import {chartWinrate} from "./chartWinrate.js";
// import {chartDaily} from "./chartDaily.js";
import {chartNewBlock} from "./chartNewBlock.js";

export const charts = (e, item, owner) => {
    if (!item) return false;

    if (e) e.preventDefault();

    const attr = item.getAttribute('data-chart');

    chartNewBlock();

    if (attr === 'monthly')
        {
            import('./chartMonthly.js').then(module => {
                module.chartMonthly();
            }).catch(err => {
                    console.log('chartMonthly load error',err);
            });
        }
    if (attr === 'winrate')
        {
            import('./chartWinrate.js').then(module => {
                module.chartWinrate();
            }).catch(err => {
                    console.log('chartWinrate load error',err);
            });
        }
    if (attr === 'daily')
        {
            import('./chartDaily.js').then(module => {
                module.chartDaily();
            }).catch(err => {
                    console.log('chartDaily load error',err);
            });
        }
    if (attr === 'chartMarketEvent')
        {
            // Промис обязан резолвиться САМИМ модулем и только после того, как
            // chartMarketEvent() отработал. Голый import() не вызовет функцию,
            // а .then(m => { m.chartMarketEvent(); }) резолвится в undefined,
            // и destroy() упадёт на undefined.destroyMarketEventChart.
            return import('./chartMarketEvent.js')
                .then(async module => {
                    await module.chartMarketEvent(owner);
                    return module;
                })
                .catch(err => {
                    console.log('chartMarketEvent load error', err);
                    throw err;
                });
        }
}